<template>
    <footer>   
        <div class="container">
		
        </div>
    </footer>

</template>

<script>
  export default {
	name: 'Footer'
  }
</script>


<style lang="scss" scoped>
	@import '../scss/style.scss';
</style>
